<template>
  <!-- 对接系统 -->
  <div class="DockingSystem">
    <!-- nav -->
    <DockingSystemHead />

    <!-- 搜索 -->
    <DockingSystemSearch />

    <!-- 日历 -->
    <DockingSystemCalendar />

    <!-- 对接系统创新活动框 -->
    <DockingSystemActivityFrame :list="CloudDockingList" />

    <!-- 推荐项目对接 NavType决定是否显示分类nav -->
    <RecommendedProject :NavType="true" :list="RecommendedList" @selectChange="selectChange" />

    <!-- 创新机构对接 -->
    <AgencyDocking :list="AgencyDockingData" />
    
    <!-- 订阅HICOOL最新资讯 -->
    <SubscriptionMsg />
  </div>
</template>

<script>
  import DockingSystemHead from "@/components/DockingSystem/Head/DockingSystemHead.vue";//对接系统的头部nav
  import DockingSystemSearch from "@/components/DockingSystem/Search/DockingSystemSearch.vue";//对接系统的头部搜索栏
  import DockingSystemCalendar from "@/components/DockingSystem/Calendar/DockingSystemCalendar.vue";//对接系统的日历组件
  import DockingSystemActivityFrame from "@/components/DockingSystem/ActivityFrame/DockingSystemActivityFrame.vue";//对接系统创新活动框
  import RecommendedProject from "@/components/DockingSystem/ActivityFrame/RecommendedProject.vue";//对接系统推荐项目框
  import AgencyDocking from "@/components/DockingSystem/ActivityFrame/AgencyDocking.vue";//对接系统推荐项目框
  import SubscriptionMsg from "@/components/DockingSystem/Submit/SubscriptionMsg.vue";//订阅HICOOL最新资讯
  import axios from "axios"
  export default {
    data() {
      return {
        CloudDockingList: [],//云对接数据
        RecommendedList: [],//推荐项目数量
        AgencyDockingData:[],//投资机构数据
      };
    },
    components: {
      DockingSystemHead,
      DockingSystemSearch,
      DockingSystemCalendar,
      DockingSystemActivityFrame,
      RecommendedProject,
      AgencyDocking,
      SubscriptionMsg
    },
    created() {
      //云对接数据
      this.getCloudDockingList();
      //项目数据
      this.getRecommendedList();
      //投资机构数据
      this.getAgencyDocking();
    },
    methods: {

      getCloudDockingList() {
        let self = this;
        //获取云对接
        axios.get('/api/jointactivitylist', {
          params: {
            territorytype: '',//领域ID
            timetype: '',//融资轮次
            limit: '6',//循环条数
            page: 1,//页数
          }
        })
          .then(function (response) {
            if (response.data.code == 0) {
              self.CloudDockingList = response.data.data;
            }
          })
          .catch(function (error) {
            console.log(error);
          });

      },
      getRecommendedList(territorytype, timetype,limit,page) {
        let self = this;
        //获取项目对接
        axios.get('/api/jointprojectlist', {
          params: {
            territorytype: territorytype,//领域ID
            timetype: timetype,//融资轮次
            limit: limit,//循环条数
            page: page,//页数
          }
        })
          .then(function (response) {
            if (response.data.code == 0) {

              self.RecommendedList = response.data.data;

            }
          })
          .catch(function (error) {
            console.log(error);
          });

      },
      //投资机构数据
      getAgencyDocking(territorytype, timetype,limit,page) {
        let self = this;
        //获取项目对接
        axios.get('/api/jointorganizationlist', {
          params: {
            territorytype: territorytype,//领域ID
            timetype: timetype,//融资轮次
            limit: limit,//循环条数
            page: page,//页数
          }
        })
          .then(function (response) {
            if (response.data.code == 0) {

              self.AgencyDockingData = response.data.data;

            }
          })
          .catch(function (error) {
            console.log(error);
          });

      },
      selectChange(payload) {

        let self = this;
        console.log('payload', payload);
        let territorytype = '';//领域ID
        let timetype = '';//融资轮次

        switch (payload.select) {
          case 'fieldSelect':
            territorytype = payload.item.id;
            break;
          //领域选择
          case 'timeSelect':
            timetype = payload.item.id;
            break;
          //融资轮次-时间选择
          case 'regionSelect':
            break;
          //地区选择

        }
        self.getRecommendedList(territorytype, timetype, 6, 1)
      },
    }

  };
</script>

<style scoped>
</style>